import { render } from "./DbsSwitch.vue?vue&type=template&id=426467ab&scoped=true"
import script from "./DbsSwitch.vue?vue&type=script&lang=js"
export * from "./DbsSwitch.vue?vue&type=script&lang=js"

import "./DbsSwitch.vue?vue&type=style&index=0&id=426467ab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426467ab"]])

export default __exports__